import { ProductTileBuilder } from '../ProductTile/ProductTileBuilder';
import AdMindClick from '../AdMind/click';

import Flickity from 'flickity';

export default () => {
  const trendingCarouselPod = document.querySelector('[data-trending-carousel]');
  if (!trendingCarouselPod) return;

  const scheme = trendingCarouselPod.getAttribute('data-scheme');

  document.addEventListener(`monetateLoaded${scheme}`, function (event) {
    const data = event.detail.monetateData;
    const title = event.detail.title;
    if (!data && !title) return;

    const mapVariants = (variants) => {
      return variants.map((variant) => {
        return {
          ...variant,
          Sellable: Number(variant.inventory) > 0,
          imgs: variant.image_url,
          Color: variant.option1,
          id: variant.variant_id,
          'Product-sku': variant.sku ? variant.sku : '',
        };
      });
    };

    const podZero = document.createElement('div');
    const headingPod = document.createElement('div');
    const heading = document.createElement('h1');

    headingPod.classList.add('TrendingCarousel__heading');
    heading.setAttribute('role', 'heading');
    heading.setAttribute('aria-level', '2');
    heading.innerText = title;
    headingPod.appendChild(heading);
    podZero.appendChild(headingPod);

    const trendingCarouselListPodZero = document.createElement('div');
    trendingCarouselListPodZero.setAttribute('data-index', '0');

    const trendingCarouselFlickityWrapper = document.createElement('div');
    trendingCarouselFlickityWrapper.classList.add('TrendingCarouselComponent', 'flickity-enabled', 'is-draggable');

    data.forEach((item) => {
      const parseVariants = mapVariants(item.Child_Attributes);

      // Guard condition: it validates if there are available and sellable variants
      if (!parseVariants.filter((variant) => variant.Sellable).length) return;

      new ProductTileBuilder(item.Title, item.product_type)
        .makeUrl(item.Detail_URL)
        .makeNode(item.item_group_id, trendingCarouselFlickityWrapper)
        .selectColor(item.selectedColor, parseVariants)
        .makeBadges(item.tags)
        .makeOptions(item.color)
        .makePrices()
        .build();
    });

    trendingCarouselListPodZero.appendChild(trendingCarouselFlickityWrapper);
    podZero.appendChild(trendingCarouselListPodZero);
    trendingCarouselPod.prepend(podZero);

    setTimeout(() => {
      const carouselOptions = {
        imagesLoaded: true,
        cellAlign: 'center',
        contain: true,
        groupCells: true,
        draggable: true,
        dragThreshold: 10,
        wrapAround: true,
        resize: true,
        on: {
          staticClick: (e, pointer, cellElement, cellIndex) => {
            const item = data[cellIndex];
            const firstVariant = item.Child_Attributes[0];
            const comparePrices = item.Child_Attributes.map((variant) => {
              return variant.compare_at_price;
            });
            const comparePriceMax = Math.max(comparePrices);

            let listName = false;
            const currentTarget = cellElement;
            const collectionName = currentTarget.closest('[data-collection]');

            if (collectionName) {
              listName = collectionName.dataset.collection;
              window.sessionStorage.setItem('rec_list_name', listName);

              if (pointer.target.tagName === 'IMG') {
                window.dataLayer.push({
                  event: 'recommendation_click',
                  product_name: item.Title,
                  product_id: item.item_group_id,
                  recommendation_item_clicked: item.item_group_id,
                  page_type: window.ShopifyAnalytics.meta.page.pageType,
                });
                console.log('recommendation_click', item.Title, item.item_group_id);
              } else {
                window.dataLayer.push({
                  event: 'quick_shop_click',
                  product_name: item.Title,
                  product_id: item.item_group_id,
                  product_to_quick_shop: item.product_id,
                  page_type: window.ShopifyAnalytics.meta.page.pageType,
                });
                console.log('quick_shop_click', item.Title, item.item_group_id);
              }

              const product = {
                id: item.item_group_id,
                title: item.Title,
                product_type: item.product_type,
                price: firstVariant.price,
                price_compare: firstVariant.compare_at_price,
                price_compare_max: comparePriceMax,
                tags: item.tags.split(','),
                variants: item.Child_Attributes,
                list_name: listName,
              };

              AdMindClick(product);
            }
          },
        },
      };

      new Flickity(trendingCarouselFlickityWrapper, carouselOptions);
    }, 0);
  });
};
